module.exports = __webpack_public_path__ + "ba27b3b67eeb00a1e66f922dc46bdf56.MP3";